// Display text for corresponding obscured values for employee count business personas
export const businessPersonasEmployeeCountDisplayTextMap: Record<string, string> = {
  e1: '1-10',
  e2: '11-50',
  e3: '51-250',
  e4: '251-1000',
  e5: '1001-5000',
  e6: '5001-10000',
  e7: '10000+',
} as const;

// Display text for corresponding obscured values for revenue business personas
export const businessPersonasRevenueDisplayTextMap: Record<string, string> = {
  r1: '$0-$999,999',
  r2: '$1,000,000-$9,999,999',
  r3: '$10,000,000-$49,999,999',
  r4: '$50,000,000-$99,999,999',
  r5: '$100,000,000-$249,999,999',
  r6: '$250,000,000-$999,999,999',
  r7: '$1,000,000,000+',
} as const;

// Display text for corresponding obscured values for primary industry business personas
export const businessPersonasPrimaryIndustryDisplayTextMap: Record<string, string> = {
  p1: 'Accessible Architecture And Design',
  p2: 'Accounting',
  p3: 'Administration Of Justice',
  p4: 'Administrative And Support Services',
  p5: 'Advertising Services',
  p6: 'Agricultural Chemical Manufacturing',
  p7: 'Agriculture, Construction, Mining Machinery Manufacturing',
  p8: 'Air, Water, And Waste Program Management',
  p9: 'Airlines And Aviation',
  p10: 'Alternative Dispute Resolution',
  p11: 'Alternative Medicine',
  p12: 'Ambulance Services',
  p13: 'Amusement Parks And Arcades',
  p14: 'Animal Feed Manufacturing',
  p15: 'Animation And Post-Production',
  p16: 'Apparel Manufacturing',
  p17: 'Appliances, Electrical, And Electronics Manufacturing',
  p18: 'Architectural And Structural Metal Manufacturing',
  p19: 'Architecture And Planning',
  p20: 'Armed Forces',
  p21: 'Artists And Writers',
  p22: 'Arts & Crafts',
  p23: 'Audio And Video Equipment Manufacturing',
  p24: 'Automation Machinery Manufacturing',
  p25: 'Automotive',
  p26: 'Aviation And Aerospace Component Manufacturing',
  p27: 'Baked Goods Manufacturing',
  p28: 'Banking',
  p29: 'Bars, Taverns, And Nightclubs',
  p30: 'Bed-And-Breakfasts, Hostels, Homestays',
  p31: 'Beverage Manufacturing',
  p32: 'Biotechnology Research',
  p33: 'Blockchain Services',
  p34: 'Blogs',
  p35: 'Book And Periodical Publishing',
  p36: 'Book Publishing',
  p37: 'Breweries',
  p38: 'Broadcast Media Production And Distribution',
  p39: 'Building Construction',
  p40: 'Building Equipment Contractors',
  p41: 'Building Finishing Contractors',
  p42: 'Building Structure And Exterior Contractors',
  p43: 'Business Consulting And Services',
  p44: 'Business Consulting and Services',
  p45: 'Business Content',
  p46: 'Business Intelligence Platforms',
  p47: 'Business Supplies & Equipment',
  p48: 'Capital Markets',
  p49: 'Caterers',
  p50: 'Chemical Manufacturing',
  p51: 'Child Day Care Services',
  p52: 'Chiropractors',
  p53: 'Civic And Social Organizations',
  p54: 'Civil Engineering',
  p55: 'Claims Adjusting, Actuarial Services',
  p56: 'Climate Technology Product Manufacturing',
  p57: 'Collection Agencies',
  p58: 'Commercial And Industrial Equipment Rental',
  p59: 'Commercial And Industrial Machinery Maintenance',
  p60: 'Commercial And Service Industry Machinery Manufacturing',
  p61: 'Commercial Real Estate',
  p62: 'Communications Equipment Manufacturing',
  p63: 'Community Development And Urban Planning',
  p64: 'Community Services',
  p65: 'Computer And Network Security',
  p66: 'Computer Games',
  p67: 'Computer Hardware Manufacturing',
  p68: 'Computer Networking',
  p69: 'Computers And Electronics Manufacturing',
  p70: 'Conservation Programs',
  p71: 'Construction Hardware Manufacturing',
  p72: 'Consumer Electronics',
  p73: 'Consumer Goods',
  p74: 'Consumer Goods Rental',
  p75: 'Consumer Services',
  p76: 'Cosmetics',
  p77: 'Cosmetology And Barber Schools',
  p78: 'Dairy Product Manufacturing',
  p79: 'Dance Companies',
  p80: 'Data Infrastructure And Analytics',
  p81: 'Data Security Software Products',
  p82: 'Defense And Space Manufacturing',
  p83: 'Dentists',
  p84: 'Design Services',
  p85: 'Desktop Computing Software Products',
  p86: 'Distilleries',
  p87: 'E-Learning Providers',
  p88: 'Economic Programs',
  p89: 'Education',
  p90: 'Education Administration Programs',
  p91: 'Electric Lighting Equipment Manufacturing',
  p92: 'Electric Power Generation',
  p93: 'Electric Power Transmission, Control, And Distribution',
  p94: 'Electrical Equipment Manufacturing',
  p95: 'Embedded Software Products',
  p96: 'Emergency And Relief Services',
  p97: 'Engineering Services',
  p98: 'Engines And Power Transmission Equipment Manufacturing',
  p99: 'Entertainment Providers',
  p100: 'Environmental Quality Programs',
  p101: 'Environmental Services',
  p102: 'Equipment Rental Services',
  p103: 'Events Services',
  p104: 'Executive Offices',
  p105: 'Executive Search Services',
  p106: 'Fabricated Metal Products',
  p107: 'Facilities Services',
  p108: 'Farming',
  p109: 'Farming, Ranching, Forestry',
  p110: 'Fashion Accessories Manufacturing',
  p111: 'Financial Services',
  p112: 'Fine Art',
  p113: 'Fine Arts Schools',
  p114: 'Fire Protection',
  p115: 'Fisheries',
  p116: 'Food And Beverage Retail',
  p117: 'Food And Beverage Services',
  p118: 'Footwear Manufacturing',
  p119: 'Forestry And Logging',
  p120: 'Freight And Package Transportation',
  p121: 'Fundraising',
  p122: 'Furniture And Home Furnishings Manufacturing',
  p123: 'Gambling Facilities And Casinos',
  p124: 'Glass Product Manufacturing',
  p125: 'Glass, Ceramics And Concrete Manufacturing',
  p126: 'Golf Courses And Country Clubs',
  p127: 'Government Administration',
  p128: 'Government Relations Services',
  p129: 'Ground Passenger Transportation',
  p130: 'Health And Human Services',
  p131: 'Health, Wellness & Fitness',
  p132: 'Higher Education',
  p133: 'Highway, Street, And Bridge Construction',
  p134: 'Historical Sites',
  p135: 'Holding Companies',
  p136: 'Home Health Care Services',
  p137: 'Horticulture',
  p138: 'Hospitality',
  p139: 'Hospitals And Health Care',
  p140: 'Hotels And Motels',
  p141: 'Housing And Community Development',
  p142: 'Housing Programs',
  p143: 'Human Resources Services',
  p144: 'Hvac And Refrigeration Equipment Manufacturing',
  p145: 'Import & Export',
  p146: 'Individual And Family Services',
  p147: 'Industrial Machinery Manufacturing',
  p148: 'Industry Associations',
  p149: 'Information Technology & Services',
  p150: 'Insurance',
  p151: 'Insurance Agencies And Brokerages',
  p152: 'Insurance And Employee Benefit Funds',
  p153: 'Interior Design',
  p154: 'International Affairs',
  p155: 'International Trade And Development',
  p156: 'Internet',
  p157: 'Internet Marketplace Platforms',
  p158: 'Internet News',
  p159: 'Internet Publishing',
  p160: 'Investment Banking',
  p161: 'Investment Management',
  p162: 'It Services And It Consulting',
  p163: 'It System Custom Software Development',
  p164: 'It System Data Services',
  p165: 'It System Design Services',
  p166: 'It System Training And Support',
  p167: 'Janitorial Services',
  p168: 'Landscaping Services',
  p169: 'Language Schools',
  p170: 'Law Enforcement',
  p171: 'Law Practice',
  p172: 'Leasing Real Estate',
  p173: 'Leasing Residential Real Estate',
  p174: 'Leather Product Manufacturing',
  p175: 'Legal Services',
  p176: 'Legislative Offices',
  p177: 'Leisure, Travel And Tourism',
  p178: 'Libraries',
  p179: 'Loan Brokers',
  p180: 'Logistics And Supply Chain',
  p181: 'Machinery Manufacturing',
  p182: 'Manufacturing',
  p183: 'Maritime Transportation',
  p184: 'Market Research',
  p185: 'Marketing Services',
  p186: 'Measuring And Control Instrument Manufacturing',
  p187: 'Mechanical Or Industrial Engineering',
  p188: 'Media And Telecommunications',
  p189: 'Medical And Diagnostic Laboratories',
  p190: 'Medical Device',
  p191: 'Medical Equipment Manufacturing',
  p192: 'Medical Practices',
  p193: 'Mental Health Care',
  p194: 'Metal Treatments',
  p195: 'Mining',
  p196: 'Mobile Computing Software Products',
  p197: 'Mobile Food Services',
  p198: 'Mobile Gaming Apps',
  p199: 'Motor Vehicle Manufacturing',
  p200: 'Motor Vehicle Parts Manufacturing',
  p201: 'Movies And Sound Recording',
  p202: 'Movies, Videos, And Sound',
  p203: 'Museums',
  p204: 'Museums, Historical Sites, And Zoos',
  p205: 'Musicians',
  p206: 'Nanotechnology Research',
  p207: 'Newspaper Publishing',
  p208: 'Non-Profit Organizations',
  p209: 'Nuclear Electric Power Generation',
  p210: 'Nursing Homes And Residential Care Facilities',
  p211: 'Office Administration',
  p212: 'Office Furniture And Fixtures Manufacturing',
  p213: 'Oil And Gas',
  p214: 'Oil, Gas, And Mining',
  p215: 'Online And Mail Order Retail',
  p216: 'Online Audio And Video Media',
  p217: 'Operations Consulting',
  p218: 'Optometrists',
  p219: 'Outsourcing And Offshoring Consulting',
  p220: 'Packaging & Containers',
  p221: 'Packaging And Containers Manufacturing',
  p222: 'Paint, Coating, And Adhesive Manufacturing',
  p223: 'Paper And Forest Product Manufacturing',
  p224: 'Performing Arts And Spectator Sports',
  p225: 'Periodical Publishing',
  p226: 'Personal Care Product Manufacturing',
  p227: 'Personal Care Services',
  p228: 'Pet Services',
  p229: 'Pharmaceutical Manufacturing',
  p230: 'Philanthropic Fundraising Services',
  p231: 'Photography',
  p232: 'Physical, Occupational And Speech Therapists',
  p233: 'Physicians',
  p234: 'Plastics And Rubber Product Manufacturing',
  p235: 'Plastics Manufacturing',
  p236: 'Political Organizations',
  p237: 'Primary And Secondary Education',
  p238: 'Printing Services',
  p239: 'Professional Organizations',
  p240: 'Professional Services',
  p241: 'Professional Training And Coaching',
  p242: 'Program Development',
  p243: 'Public Health',
  p244: 'Public Policy Offices',
  p245: 'Public Relations And Communications Services',
  p246: 'Public Safety',
  p247: 'Radio And Television Broadcasting',
  p248: 'Rail Transportation',
  p249: 'Railroad Equipment Manufacturing',
  p250: 'Ranching',
  p251: 'Real Estate Agents And Brokers',
  p252: 'Real Estate And Equipment Rental Services',
  p253: 'Recreational Facilities',
  p254: 'Religious Institutions',
  p255: 'Renewable Energy Equipment Manufacturing',
  p256: 'Renewable Energy Power Generation',
  p257: 'Renewable Energy Semiconductor Manufacturing',
  p258: 'Renewables And Environment',
  p259: 'Repair And Maintenance',
  p260: 'Research',
  p261: 'Research Services',
  p262: 'Residential Building Construction',
  p263: 'Restaurants',
  p264: 'Retail',
  p265: 'Retail Apparel And Fashion',
  p266: 'Retail Appliances, Electrical, And Electronic Equipment',
  p267: 'Retail Art Dealers',
  p268: 'Retail Art Supplies',
  p269: 'Retail Books And Printed News',
  p270: 'Retail Building Materials And Garden Equipment',
  p271: 'Retail Florists',
  p272: 'Retail Furniture And Home Furnishings',
  p273: 'Retail Groceries',
  p274: 'Retail Health And Personal Care Products',
  p275: 'Retail Luxury Goods And Jewelry',
  p276: 'Retail Motor Vehicles',
  p277: 'Retail Musical Instruments',
  p278: 'Retail Office Equipment',
  p279: 'Retail Office Supplies And Gifts',
  p280: 'Retail Pharmacies',
  p281: 'Retail Recyclable Materials & Used Merchandise',
  p282: 'Robotics Engineering',
  p283: 'Seafood Product Manufacturing',
  p284: 'Security And Investigations',
  p285: 'Security Guards And Patrol Services',
  p286: 'Security Systems Services',
  p287: 'Semiconductor Manufacturing',
  p288: 'Services For Renewable Energy',
  p289: 'Services For The Elderly And Disabled',
  p290: 'Shipbuilding',
  p291: 'Shuttles And Special Needs Transportation Services',
  p292: 'Sightseeing Transportation',
  p293: 'Social Networking Platforms',
  p294: 'Software Development',
  p295: 'Solar Electric Power Generation',
  p296: 'Sound Recording',
  p297: 'Space Research And Technology',
  p298: 'Specialty Trade Contractors',
  p299: 'Spectator Sports',
  p300: 'Sporting Goods Manufacturing',
  p301: 'Sports',
  p302: 'Sports And Recreation Instruction',
  p303: 'Sports Teams And Clubs',
  p304: 'Strategic Management Services',
  p305: 'Surveying And Mapping Services',
  p306: 'Taxi And Limousine Services',
  p307: 'Technical And Vocational Training',
  p308: 'Technology, Information And Internet',
  p309: 'Technology, Information And Media',
  p310: 'Telecommunications',
  p311: 'Telephone Call Centers',
  p312: 'Textile Manufacturing',
  p313: 'Theater Companies',
  p314: 'Think Tanks',
  p315: 'Tobacco Manufacturing',
  p316: 'Translation And Localization',
  p317: 'Transportation Programs',
  p318: 'Transportation, Logistics, Supply Chain And Storage',
  p319: 'Travel Arrangements',
  p320: 'Truck Transportation',
  p321: 'Trusts And Estates',
  p322: 'Utilities',
  p323: 'Utility System Construction',
  p324: 'Vehicle Repair And Maintenance',
  p325: 'Venture Capital And Private Equity Principals',
  p326: 'Veterinary Services',
  p327: 'Warehousing And Storage',
  p328: 'Waste Collection',
  p329: 'Waste Treatment And Disposal',
  p330: 'Water Supply And Irrigation Systems',
  p331: 'Water, Waste, Steam, And Air Conditioning Services',
  p332: 'Wellness and Fitness Services',
  p333: 'Wellness And Fitness Services',
  p334: 'Wholesale',
  p335: 'Wholesale Alcoholic Beverages',
  p336: 'Wholesale Appliances, Electrical, And Electronics',
  p337: 'Wholesale Building Materials',
  p338: 'Wholesale Chemical And Allied Products',
  p339: 'Wholesale Food And Beverage',
  p340: 'Wholesale Hardware, Plumbing, Heating Equipment',
  p341: 'Wholesale Import And Export',
  p342: 'Wholesale Luxury Goods And Jewelry',
  p343: 'Wholesale Machinery',
  p344: 'Wholesale Metals And Minerals',
  p345: 'Wholesale Motor Vehicles And Parts',
  p346: 'Wholesale Petroleum And Petroleum Products',
  p347: 'Wholesale Recyclable Materials',
  p348: 'Wine & Spirits',
  p349: 'Wineries',
  p350: 'Wireless Services',
  p351: 'Wood Product Manufacturing',
  p352: 'Writing And Editing',
} as const;
